// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Profile = function Profile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.125 5a3.125 3.125 0 1 0-6.25 0 3.125 3.125 0 0 0 6.25 0M5 5a5 5 0 1 1 10 0A5 5 0 0 1 5 5M3.176 18.125h13.652a5.09 5.09 0 0 0-5.039-4.375H8.22a5.09 5.09 0 0 0-5.04 4.375zm-1.926.715a6.963 6.963 0 0 1 6.965-6.965h3.57a6.963 6.963 0 0 1 6.965 6.965c0 .64-.52 1.16-1.16 1.16H2.41c-.64 0-1.16-.52-1.16-1.16"
  }));
};
